module.exports = __webpack_public_path__ + "img/suspended.c231a88e.svg";